(() => {
  const els = document.querySelectorAll("[data-kfr-reveal]");
  if (!els.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add("is-in");
      });
    },
    { threshold: 0.15 }
  );

  els.forEach((el) => io.observe(el));

  // Optional: smooth jump to Room Fit section when teaser clicked
  document.querySelectorAll("[data-kfr-roomfit-jump]").forEach((a) => {
    a.addEventListener("click", (ev) => {
      const target = document.querySelector("#kfr-room-fit");
      if (!target) return;
      ev.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
})();
